import $ from 'jquery'
import StarRating from './components/star-rating.js'
import select2 from "select2"
import SumoSelect from './components/jquery.sumoselect.min'
import Swiper, {Navigation, Pagination} from 'swiper'
import Event from "./components/Event"
import Tabs from './components/Tabs'
import Acco from "./components/Acco"
import ArticleCode from "./components/ArticleCode"
import TopicCard from "./components/TopicCard"
import Dropdown from "./components/Dropdown"
import Video from "./components/Video"
import HeaderSearch from "./components/HeaderSearch"
import DocumentContents from "./components/DocumentContents"
import DocumentNav from "./components/DocumentNav";
import EventInfo from "./components/EventInfo"
import ThemeSwitch from "./components/ThemeSwitch"
import "./components/modal"
import Prism from 'prismjs'
import "./components/form"
import moment from 'moment'
import './components/daterangepicker.js'
import CookieAlert from './components/CookieAlert.js'

window.jQuery = $
window.$ = $

jQuery(function(){
  if (getCookie('theme')) {
    $('html').attr('data-theme', getCookie('theme'))
  }

  document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`)

  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ))
    return matches ? decodeURIComponent(matches[1]) : undefined
  }

  const stars = new StarRating('.star-rating')

  $('.js-select2').each(function() {

    const placeholder = $(this).attr('data-placeholder')
    $(this).select2(
      {
        placeholder: placeholder,
        minimumResultsForSearch: Infinity,
        dropdownCssClass: "select__dropdown",
        selectionCssClass: 'select__selection'
      }
    )
  })

  $('.js-select').on("change", function (){
    $(this).removeClass('error')
  })

  $('.js-select-dropdown').SumoSelect();

  $('[data-switch]').each((i,el) => {
    new ThemeSwitch(el)
  })

  $('[data-event-id]').each((i,el) => {
    new Event(el)
  })

  $('[data-js-tabs]').each((i,el) => {
    new Tabs(el)
  })

  $('[data-component="Acco"]').each((i,el) => {
    new Acco(el)
  })

  $('.article-code').each((i,el) => {
    new ArticleCode(el)
  })

  $('.topic-card').each((i,el) => {
    new TopicCard(el)
  })

  $('.base-dropdown').each((i,el) => {
    new Dropdown(el)
  })

  $('.video-card').each((i,el) => {
    new Video(el)
  })

  $('.header-search').each((i,el) => {
    new HeaderSearch(el)
  })

  $('.document-contents').each((i,el) => {
    new DocumentContents(el)
  })

  $('.document-menu').each((i,el) => {
    new DocumentNav(el)
  })

  $('.event-info').each((i,el) => {
    new EventInfo(el)
  })

  $('.cookies-alert').each((_, el) => {
    new CookieAlert(el)
  })

  if ($('body').find('.date-input').length) {

    console.log('test')

    const direction = window.innerWidth < 1025 ? 'up' : 'down'

    $('.js-double-date').daterangepicker({
      autoUpdateInput: false,
      linkedCalendars: true,
      autoApply: true,
      locale: {
        cancelLabel: 'Очистить',
        applyLabel: 'Применить',
        "format": "MM.DD.YYYY",
        "separator": " - ",
        "fromLabel": "От",
        "toLabel": "До",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "Вс",
          "Пн",
          "Вт",
          "Ср",
          "Чт",
          "Пт",
          "Сб"
        ],
        "monthNames": [
          "Январь",
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сентябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь"
        ],
        "firstDay": 1
      },
      drops: direction
    });

    $('.js-double-date').on('apply.daterangepicker', function(ev, picker) {
      $(this).val(picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('DD.MM.YYYY'));
      $(this).change()
    });

    $('.js-double-date').on('cancel.daterangepicker', function(ev, picker) {
      $(this).val('');
      $(this).change()
    });

    $('.js-single-date').daterangepicker({
      singleDatePicker: true,
      startDate: moment()
    });
  }

  const videoSwiper = new Swiper('.video-swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 12,
    mousewheel: true,
    observer: true,
    observeParents: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 32,
      }
    }
  })

  $('.document-contents__nav-link').on('click', function (e) {
    e.preventDefault();
    let curLink = $(this).attr('href');
    let scroll = $(curLink).offset();
    $('html,body').stop().animate({
      scrollTop: scroll.top - 100
    }, 500);
  });
})
